(function ($) {
    function breadcrumb() {
        var page_url = window.location.href,
            menu_column = $('.nav-main'),
            sub_items = $('.nav-main li.menu-item a'),
            breadcrumb = $('.menu-breadcrumb-items'),
            menu_columns_children = null,
            items_found,
            element_href;

        $(sub_items).each(function () {
            element_href = $(this).attr('href');

            if ( !$(this).parent().hasClass('current-menu-parent') ) {
                if ( page_url === element_href ) {

                    menu_columns_children = $(this).parentsUntil( menu_column );

                    for (var i = 0; i < menu_columns_children.length; i++) {
                        if ( $(menu_columns_children[i])[0].nodeName !== 'UL' && $(menu_columns_children[i])[0].nodeName !== 'DIV' ) {
                            items_found = $(menu_columns_children[i]).find('a').filter('a:first').first();

                            var clonedItem = $(items_found).clone();
                            clonedItem.clone().prependTo(breadcrumb);
                        }
                    }
                }
            }
        });
    }

    $(document).ready(function () {
        breadcrumb();
        var h1_lead = $('.doc-section .ns-title-h1-with-lead').first();
        var breadcrumbPlaceholder = $('.menu-breadcrumb-items');

        if( h1_lead.length > 0 ) {
            breadcrumbPlaceholder.insertBefore(h1_lead);
            if(breadcrumbPlaceholder.children().first().html() !== undefined){
                $("<h2 class='ns-title-h2 breadcrumb'>" + breadcrumbPlaceholder.children().first().html() +"</h2>").insertBefore(breadcrumbPlaceholder);
            }
            breadcrumbPlaceholder.remove();
        }
    });
})(jQuery);